import { injectable } from 'inversify';
import { plainToClass } from 'class-transformer';

import { ValidationService } from '@vk-hr-tek/core/validation';
import { Filter, FilterService } from '@vk-hr-tek/core/filter';

import { AttorneyListRequestFilter, UsersService } from '@app/gen/attorneys';

import { GetAttorneysListDto } from '../../dto';

@injectable()
export class AttorneysListService {
  constructor(
    private validator: ValidationService,
    private filterService: FilterService,
    private attorneyService: UsersService,
  ) {}

  async getAttorneysList(
    getAttorneysListDto: GetAttorneysListDto,
    availableFilters: Filter[],
  ) {
    const attorneysDto = plainToClass(
      this.filterService.buildDto(GetAttorneysListDto, availableFilters),
      getAttorneysListDto,
    );

    await this.validator.validateOrReject(attorneysDto);

    const filters = {
      ...(attorneysDto.filters || {}),
    } as AttorneyListRequestFilter;

    filters.company_id = attorneysDto.company_id;

    const { limit = 50, offset = 0 } = attorneysDto;

    const result = await this.attorneyService.attorneyList({
      body: {
        filter: filters,
        limit,
        offset,
      },
    });

    return result;
  }
}
